import {
  Container,
  Heading,
  Hidden,
  Visible
} from '@leroy-merlin-br/backyard-react'

import * as S from './styled'

const LEROY_MERLIN_PAY_URL =
  'https://www.leroymerlin.com.br/modular/leroy-merlin-pay-'

const LEROY_MERLIN_PAY_DESKTOP_BANNERS = [
  'https://cdn.leroymerlin.com.br/uploads/img/banners/desk_%7C_conta_digital_1_%7C_lm_pay_5ac8_1180x320.png',
  'https://cdn.leroymerlin.com.br/uploads/img/banners/desk_%7C_conta_digital_2_%7C_lm_pay_81f7_1180x320.png'
]

const LEROY_MERLIN_PAY_MOBILE_BANNERS = [
  'https://cdn.leroymerlin.com.br/uploads/img/banners/mob_%7C_conta_digital_2_%7C_lm_pay_e1d5_1024x546.png',
  'https://cdn.leroymerlin.com.br/uploads/img/banners/mob_%7C_conta_digital_3_%7C_lm_pay_7694_1024x546.png'
]

const PayBanner = () => (
  <S.Section>
    <Container>
      <S.TitleWrapper>
        <Heading as="h2" size="exa" noMargin>
          Abra sua conta Leroy Merlin Pay para começar a receber os lucros!
        </Heading>
      </S.TitleWrapper>

      <Visible when={['untilKilo', 'kilo', 'mega']}>
        <S.BannersLink
          href={LEROY_MERLIN_PAY_URL}
          target="_blank"
          rel="noopener noreferrer">
          {LEROY_MERLIN_PAY_MOBILE_BANNERS.map((bannerUrl, index) => (
            <S.BannerImage
              key={bannerUrl}
              src={bannerUrl}
              alt={`Banner Leroy Merlin Pay mobile ${index + 1}`}
            />
          ))}
        </S.BannersLink>
      </Visible>

      <Hidden when={['untilKilo', 'kilo', 'mega']}>
        <S.BannersLink
          href={LEROY_MERLIN_PAY_URL}
          target="_blank"
          rel="noopener noreferrer">
          {LEROY_MERLIN_PAY_DESKTOP_BANNERS.map((bannerUrl, index) => (
            <S.BannerImage
              key={bannerUrl}
              src={bannerUrl}
              alt={`Banner Leroy Merlin Pay desktop ${index + 1}`}
            />
          ))}
        </S.BannersLink>
      </Hidden>
    </Container>
  </S.Section>
)

export default PayBanner
